export default "/images/vendor/flag-icon-css/flags/4x3/sa.svg?b9a346574cdc8950dd34b50780441f57";